import { all, call } from 'redux-saga/effects';
import apiRootSaga from './api/sagas';
import appRootSaga from './application/sagas';
import authRootSaga from './authentication/sagas';
import formRootSaga from './form/sagas';
import saveRootSaga from './save/sagas';
import sectionRootSaga from './section/sagas';
// import { default as navigateRootSata } from './navigate/sagas'

export default function* rootSaga() {
  yield all([
    call(apiRootSaga),
    call(appRootSaga),
    call(authRootSaga),
    call(formRootSaga),
    call(saveRootSaga),
    call(sectionRootSaga),
    // Disabled. Re-eanble for EN-5432.
    // call(navigateRootSata),
  ]);
}
